import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
export const initSentry = user => {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.4,
    debug: process.env.NODE_ENV === "development",
    environment: process.env.SENTRY_ENVIRONMENT,
    release: process.env.SENTRY_RELEASE
  });
  Sentry.configureScope(scope => {
    var _navigator;

    scope.setTag("locale", (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.language);
    scope.setTag("commit", process.env.SENTRY_RELEASE);
    scope.setTag("is_analytics_enable", process.env.ANALYTICS_ENABLE);
    scope.setUser({
      email: user.email,
      id: user.tracking_id
    });
  });
};
export const sentryReduxEnhancer = Sentry.createReduxEnhancer({});